<app-breadcrumbs></app-breadcrumbs>
<div id="meraki-admin-table-wrapper">
    <div [cfaLoading]="isLoading">
        <mat-form-field>
            <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter">
        </mat-form-field>
    </div>
    <table id="meraki-admin-table" #adminTable mat-table [dataSource]="dataSource" class="mat-elevation-z8">
        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef> Name </th>
            <td mat-cell *matCellDef="let admin"> {{admin.name}} </td>
        </ng-container>
        <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef> Email </th>
            <td mat-cell *matCellDef="let admin"> {{admin.email}} </td>
        </ng-container>
        <ng-container matColumnDef="orgAccess">
            <th mat-header-cell *matHeaderCellDef> Organization Access </th>
            <td mat-cell *matCellDef="let admin"> {{admin.orgAccess}} </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    <mat-paginator [pageSizeOptions]="[10, 20, 30, 50]" showFirstLastButtons></mat-paginator>
</div>